// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import {CapsuleChain,type CapsuleProfile} from '../Capsule'
import {Plate} from '../Plate'
import {BALL_RADIUS} from '../constants'
import type {Ball} from '../Ball'
import type {World} from '../World'

/** Analytic contacts fitted to the authored channel; the front shot stays open. */
export class CaptiveCage {
 private readonly rails:CapsuleChain
 private readonly stop:Plate
 private readonly pad:Plate
 constructor(cx:number,cy:number,ux:number,uy:number,travel:number){
  const point=(x:number,y:number,z:number):readonly [number,number,number]=>[cx+uy*x+ux*y,cy-ux*x+uy*y,z]
  const profiles:CapsuleProfile[]=[]
  for(const side of [-1,1]){
   const x=side*.0165
   profiles.push({a:point(x,-.017,.0154),b:point(x,travel+.019,.0154),radius:.0014})
   for(const y of [-.014,travel+.016])profiles.push({a:point(x,y,.0012),b:point(x,y,.0142),radius:.002})
   profiles.push({a:point(x,-.0155,.0154),b:point(x,-.0155,.0306),radius:.0012})
  }
  profiles.push({a:point(-.0165,-.0155,.0306),b:point(.0165,-.0155,.0306),radius:.0012})
  this.rails=new CapsuleChain(profiles)
  const back=travel+BALL_RADIUS+.00175
  const plate=(half:number,front:number,rear:number,bottom:number,top:number,material:'metal'|'rubber')=>new Plate({referenceLength:1,outline:[[-half,-front],[half,-front],[half,-rear],[-half,-rear]],bottom,top,material},cx-uy*.5,cy+ux*.5,cx+uy*.5,cy-ux*.5)
  this.stop=plate(.0155,back-.001,back+.001,.0012,.0252,'metal')
  this.pad=plate(.0125,back-.001749,back-.001,.003,.024,'rubber')
 }
 resolve(world:World,ball:Ball):boolean{
  if(ball.heldBy>=0||ball.layer!==0)return false
  let hit=this.rails.resolve(world,ball)
  if(this.stop.resolve(world,ball))hit=true
  if(this.pad.resolve(world,ball))hit=true
  return hit
 }
}
